import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { ActionCreators } from 'redux-undo';
import { removeFunnel } from '../../../../../reducers/united-canvas/unitedCanvasReducer';
import { useFunnelsApiFacade } from '../../../../../apis/facades/useFunnelsApiFacade';

export const useRemoveDeleteSfFunnelFromCanvas = () => {
  const dispatch = useDispatch();
  const { delete_funnel } = useFunnelsApiFacade();

  const handleRemoveFromCanvas = useCallback(
    (funnelId: string) => {
      dispatch(removeFunnel({ funnelId }));
    },
    [dispatch],
  );

  const handleDeleteFunnel = useCallback(
    async (funnelId: string) => {
      await delete_funnel(funnelId);
      dispatch(ActionCreators.clearHistory());
      handleRemoveFromCanvas(funnelId);
    },
    [delete_funnel, dispatch, handleRemoveFromCanvas],
  );

  return {
    handleDeleteFunnel,
    handleRemoveFromCanvas,
  };
};
